export default "__VITE_ASSET__BV0Ri98m__"